import { render, staticRenderFns } from "./InitiateReversalForm.vue?vue&type=template&id=22f863d4&scoped=true&"
import script from "./InitiateReversalForm.vue?vue&type=script&lang=js&"
export * from "./InitiateReversalForm.vue?vue&type=script&lang=js&"
import style0 from "./InitiateReversalForm.vue?vue&type=style&index=0&id=22f863d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f863d4",
  null
  
)

export default component.exports